import React from 'react';

const DIRECTION_OPTIONS = [
  { value: '', label: '—' },
  { value: 'inbound', label: 'Inbound (from counterparty)' },
  { value: 'outbound', label: 'Outbound (to counterparty)' },
  { value: 'internal', label: 'Internal' },
];

function FieldHint({ children }) {
  if (!children) {
    return null;
  }

  return (
    <div className="muted" style={{ fontSize: 10.5, marginTop: 4, lineHeight: 1.4 }}>
      {children}
    </div>
  );
}

export default function ContractFileVersionFields({
  dateHint = 'Date on the file itself.',
  direction,
  directionHint = 'Who last handled this version.',
  documentDate,
  fileNotes,
  intro,
  notesLabel = 'File notes',
  notesOptional = false,
  notesPlaceholder = 'Short context about this version',
  onChange,
  style,
}) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 12,
        alignItems: 'start',
        ...style,
      }}
    >
      {intro && (
        <div
          className="muted"
          style={{ gridColumn: '1 / -1', fontSize: 11, lineHeight: 1.5, marginBottom: 4 }}
        >
          {intro}
        </div>
      )}
      <div>
        <label className="field-label">Document date</label>
        <input
          type="date"
          value={documentDate || ''}
          onChange={(e) => onChange('documentDate', e.target.value)}
          className="input"
          style={{ width: '100%' }}
        />
        <FieldHint>{dateHint}</FieldHint>
      </div>
      <div>
        <label className="field-label">Direction</label>
        <select
          value={direction || ''}
          onChange={(e) => onChange('direction', e.target.value)}
          className="select"
          style={{ width: '100%' }}
        >
          {DIRECTION_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <FieldHint>{directionHint}</FieldHint>
      </div>
      <div style={{ gridColumn: '1 / -1' }}>
        <label className="field-label">
          {notesLabel}
          {notesOptional && (
            <span className="muted" style={{ fontWeight: 450, marginLeft: 4 }}>
              (optional)
            </span>
          )}
        </label>
        <input
          type="text"
          value={fileNotes || ''}
          onChange={(e) => onChange('fileNotes', e.target.value)}
          placeholder={notesPlaceholder}
          className="input"
          style={{ width: '100%' }}
          maxLength={2000}
        />
      </div>
    </div>
  );
}
